import { render, staticRenderFns } from "./DashboardSolicitudes.vue?vue&type=template&id=1c4d61bd&scoped=true"
import script from "./DashboardSolicitudes.vue?vue&type=script&lang=js"
export * from "./DashboardSolicitudes.vue?vue&type=script&lang=js"
import style0 from "./DashboardSolicitudes.vue?vue&type=style&index=0&id=1c4d61bd&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4d61bd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\capredena\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c4d61bd')) {
      api.createRecord('1c4d61bd', component.options)
    } else {
      api.reload('1c4d61bd', component.options)
    }
    module.hot.accept("./DashboardSolicitudes.vue?vue&type=template&id=1c4d61bd&scoped=true", function () {
      api.rerender('1c4d61bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/dashboardSolicitudes/DashboardSolicitudes.vue"
export default component.exports